import { useState } from "react";
import "./MenuSlider.scss";

const MenuSlider = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="main-side-menu">
      <div className="menu-icon" onClick={toggleMenu}>
        ☰ {/* Ícone de menu (pode ser um ícone de sua escolha) */}
      </div>
      <nav className={`side-menu ${isOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={toggleMenu}>
          &times;
        </button>

        <ul>
          <li>
            <a href="/#aboutUs" onClick={toggleMenu}>
              Início
            </a>
          </li>
          <li>
            <a href="#solutions" onClick={toggleMenu}>
              Soluções
            </a>
          </li>
          <li>
            <a href="/blog" onClick={toggleMenu}>
              Blog
            </a>
          </li>
          <li>
            <a href="/work-with-us" onClick={toggleMenu}>
              Trabalhe Conosco
            </a>
          </li>
          <li>
            <a href="/talk" onClick={toggleMenu}>
              Contato
            </a>
          </li>
        </ul>
      </nav>
      {isOpen && <div className="overlay" onClick={toggleMenu}></div>}
    </div>
  );
};

export default MenuSlider;
